import z from 'zod'

export const TimesheetBreakID = z.string().brand<'TimesheetBreakID'>()
export type TimesheetBreakID = z.infer<typeof TimesheetBreakID>

export const TimesheetBreak = z
  .object({
    id: z.string(),
  })
  .transform((obj) => ({
    id: obj.id,
  }))

export type TimesheetBreakSchema = z.input<typeof TimesheetBreak>
export type TimesheetBreak = z.output<typeof TimesheetBreak>